import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Body from "../../body/BodyPage";
import MainLinks from "../../navlinks/MainLinks";
import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBBtn,
  MDBChip,
  MDBCol,
  MDBDatatable,
  MDBIcon,
  MDBRow,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBSelect,
  MDBSpinner,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
} from "mdb-react-ui-kit";
import { Tooltip } from "react-tooltip";
import PopupLoader from "../../../views/popups/PopupLoader";
import AddToUsers from "../../../views/popups/misc/AddToUsers";
import TelephoneNumbers from "../../TelephoneNumbers";
import { AddRemoveNumbers } from "../../../views/popups/phonenumbers/AddRemoveNumbers";
import { useLocation, useNavigate } from "react-router";
import { useForm } from "react-hook-form";
import {
  getMisc,
  getSpecificSMSGrpDetails,
  updateSMSGroup,
} from "../../../apiclients/streamsapi_bridge";
import SMSGenralSettings from "./SMSGenralSettings";
import TopSuccess from "../../header/TopSuccess";
import TopMessage from "../../header/TopMessage";
import SaveChanges from "../../topviews/saveCancel";
import SMSGroupUsers from "./SMSGroupUsers";
import { defaultUImg } from "../../images";
import EditWarning from "../../header/EditWarning";
import { useAdminContext } from "../../adminstore/Admin-Context";
function SMSGroupsEditMain() {
  const containerRef = useRef(null);
  const section1 = useRef(null);
  const section2 = useRef(null);
  const containerRef2 = useRef(null);
  const section3 = useRef(null);
  const location = useLocation();
  const [smsGroupInfo, setsmsGroupInfo] = useState(
    location.state ? location.state : {}
  );
  const [rerender, setRerender] = useState(false);
  const [isloading, setIsloading] = useState(false);

  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const [basicActive, setBasicActive] = useState("tab1");
  const [smsDIDs, setsmsDIDs] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [smsUsers, setsmsUsers] = useState([]);
  const navigate = useNavigate();
  const { isEdited, setEdited } = useAdminContext();
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    if (isEdited) {
      setTargetView(value);
      setShowWarning(true);
      return;
    }

    setBasicActive(value);
  };

  const handleOk = () => {
    setEdited(false);
    reset();
    if (targetView.indexOf("/") !== -1) {
      navigate(targetView);
    } else {
      setBasicActive(targetView);
    }
    setShowWarning(false);
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isDirty, dirtyFields },
    setValue,
    watch,
    setError,
    clearErrors,
  } = useForm({
    defaultValues: {
      allow_user_tochange_smsdid: false,
      billing_grp: 0,
      loc_id: 0,
      primary_did: "",
    },
  });

  async function getSpecificSMSGroups() {
    try {
      setIsloading(true);
      const response = await getSpecificSMSGrpDetails(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        smsGroupInfo.code
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      const smsGroupDetails = await response.json();
      console.log(
        "getSpecific getSpecificSMSGroups ::: " +
        JSON.stringify(smsGroupDetails)
      );
      // setaliasName(phoneDetails?.general?.alias_name ?? "");
      // setphonenum(formattedNumber(pNumInfo.phnumber));
      setsmsDIDs(smsGroupDetails?.General_settings?.did ?? []);
      setsmsUsers(smsGroupDetails?.Users ?? []);

      const smsDetails = {
        allow_user_tochange_smsdid:
          smsGroupDetails?.General_settings?.allowusertochangesmsdid ?? false,
        billing_grp: smsGroupDetails?.General_settings?.billing_groups?.groupid
          ? parseInt(smsGroupDetails.General_settings.billing_groups.groupid)
          : 1
        ,
        loc_id: smsGroupDetails?.General_settings?.loc_id
          ? parseInt(smsGroupDetails?.General_settings?.loc_id)
          : "",
        primary_did: smsGroupDetails?.General_settings?.primarysmsdid ?? "",
      };
      reset(smsDetails);

      setRerender(false);
    } catch (error) { }
  }

  useEffect(() => {
    if (smsGroupInfo.code || rerender) {
      getSpecificSMSGroups();
    }
  }, [smsGroupInfo.code, rerender]);

  const isSave = Object.keys(dirtyFields).length === 0 ? false : true;

  useEffect(() => {
    setEdited(isSave);
  }, [isSave]);

  const onSubmit = async (data) => {
    let modifiedData = {};

    Object.entries(dirtyFields).forEach(([key, value]) => {
      modifiedData[key] = data[key];
    });
    if (modifiedData) {
      modifiedData.reqid = 100;
      modifiedData.siteid = JSON.parse(
        sessionStorage.getItem("admin_session")
      ).siteid;
      modifiedData.code = parseInt(smsGroupInfo.code);

      console.log(
        "modified data for company info :::" + JSON.stringify(modifiedData)
      );
      setIsloading(true);
      let saverep = await updateSMSGroup(modifiedData);
      console.log(`reponse of Edit SMS Group :::: ${JSON.stringify(saverep)}`);
      let saverepeMsg = await saverep.json();
      console.log(
        "response of modified data SMS Group  :::" + JSON.stringify(saverepeMsg)
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setRerender(true);
        setSuccessMessage(saverepeMsg.message);
      } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
              fieldElement.scrollIntoView({ behavior: "smooth" });
            }
          });
        }
      }
    }
  };

  function closeSave(e) {
    reset();
  }

  const [addNumber, setAddNumber] = useState(false);
  const toggleOpen2 = () => setAddNumber(!addNumber);

  return (
    <React.Fragment>
      <>
        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={283}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      <MDBBreadcrumb>
                        <MDBBreadcrumbItem>
                          <a
                            onClick={(e) => {
                              if (isEdited) {
                                setTargetView("/userlanding");
                                setShowWarning(true);
                                return;
                              }
                              navigate("/phonenumbers");
                            }}
                          >
                            <strong>{t("phoneSystem")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>
                          <a href="/smsgroupslanding">
                            <strong>{t("smsgroups")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>
                          <a href="">
                            <strong>{smsGroupInfo.name} Group</strong>
                          </a>
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>
                    </h5>
                  </div>
                  <div>
                    <div className="d-flex align-items-center">
                      <div>
                        <div className="user-profilePicture">
                          {/* <div className="profile-mask">
                            <MDBIcon
                              far
                              icon="edit"
                              color="white"
                              className="fs-5 EditProfile cursor-pointer"
                            />
                            <MDBIcon
                              className="ms-4 fs-5"
                              fas
                              icon="times"
                              color="white RemoveProfile cursor-pointer"
                            />
                          </div> */}
                          <img
                            src={defaultUImg}
                            // src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlciUyMHByb2ZpbGV8ZW58MHx8MHx8fDA%3D"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="ps-3">
                        <div className="userName">
                          <h5 className="fw-600 mt-2 ">{smsGroupInfo.name}</h5>
                          <p className="m-0 d-flex align-items-center">
                            {smsGroupInfo.mailid}
                          </p>
                        </div>
                      </div>
                    </div>

                    <MDBTabs className="mb-3">
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab1")}
                          active={basicActive === "tab1"}
                        >
                          {t("settings")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab2")}
                          active={basicActive === "tab2"}
                        >
                          {t("users")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                    </MDBTabs>

                    <MDBTabsContent>
                      <MDBTabsPane open={basicActive === "tab1"}>
                        {/* Tab 1 content */}
                        <MDBRow>
                          <MDBCol
                            size="2"
                            md="2"
                            lg="2"
                            sm="12"
                            className="col-sm-100 pr-0 leftTabs"
                          >
                            <div className="position-relative">
                              <MDBScrollspy
                                container={containerRef}
                                defaultActive="general"
                              >
                                <MDBScrollspyLink
                                  targetRef={section1}
                                  id="general"
                                >
                                  {t("general")}
                                </MDBScrollspyLink>
                                {/* <MDBScrollspyLink targetRef={section2}>
                                                                    {t("billing")}
                                                                </MDBScrollspyLink> */}
                              </MDBScrollspy>
                            </div>
                          </MDBCol>
                          <MDBCol
                            size="12"
                            md="10"
                            sm="12"
                            pr-0
                            className="col-sm-100 pr-0 leftTabContent"
                          >
                            <div
                              id="element"
                              ref={containerRef}
                              className="scrollspy-example2"
                            >
                              <section ref={section1} id="section-1">
                                <SMSGenralSettings
                                  register={register}
                                  watch={watch}
                                  errors={errors}
                                  setValue={setValue}
                                  smsDIDs={smsDIDs}
                                  setSuccessMessage={setSuccessMessage}
                                  setRerender={setRerender}
                                  code={smsGroupInfo.code}
                                  setIsloading={setIsloading}

                                />
                              </section>
                              {isSave && (
                                <SaveChanges
                                  onClose={closeSave}
                                  isdirtyFields={isSave}
                                  onSave={(e) => {
                                    e.preventDefault();
                                    handleSubmit(onSubmit)();
                                  }}
                                />
                              )}
                            </div>
                          </MDBCol>
                        </MDBRow>
                      </MDBTabsPane>
                      <MDBTabsPane open={basicActive === "tab2"}>

                        <SMSGroupUsers
                          smsUsers={smsUsers}
                          code={smsGroupInfo.code}
                          isActive={basicActive === "tab2"}
                        />

                      </MDBTabsPane>
                    </MDBTabsContent>
                  </div>
                </div>
              </section>
            </>
          }
        />

        <Tooltip
          Tooltip
          anchorSelect=".EditProfile"
          place="top"
          className="exampleTooltip"
        >
          Edit Profile
        </Tooltip>
        <Tooltip
          anchorSelect=".RemoveProfile"
          place="top"
          className="exampleTooltip"
        >
          Remove Profile
        </Tooltip>
        <Tooltip
          anchorSelect=".deleteToolTip"
          place="top"
          className="exampleTooltip"
        >
          Delete
        </Tooltip>
        {isloading && (
          <>
            <div className="loadingclass">
              <MDBBtn disabled>
                <MDBSpinner
                  size="sm"
                  role="status"
                  tag="span"
                  className="me-2"
                />
                Loading...
              </MDBBtn>
            </div>
          </>
        )}
        {successMessage && (
          <>
            <TopSuccess>
              <TopMessage successMessage={successMessage} />
            </TopSuccess>
          </>
        )}

        {showWarning && (
          <EditWarning
            warningToggle={warningToggle}
            setShowWarning={setShowWarning}
            onOk={handleOk}
          />
        )}
      </>
    </React.Fragment>
  );
}

export default SMSGroupsEditMain;
